import React, { useState, useEffect, useRef } from "react";
// import { Box, Button, Grid, Typography, Stack, TextField, Menu, MenuItem, IconButton, Divider } from "@mui/material";
import { Box, Stack, Typography, TextField, IconButton, List, ListItem, ListItemText, ListItemIcon, Divider } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import PlaceIcon from '@mui/icons-material/Place';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import OtherDetails from "./OtherDetails";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { MapDetails3 } from "../../../store/types";
import { useDispatch } from "react-redux";
import { setCurrentFloor } from "../../../store/map/mapSlice";
import { VIEW } from "../../../utils/breakpoint";
import { customLog } from "../../../utils/utils";
import { getMapLevelLabel } from "../../../lib/api/function";
import { COLOR } from "../../../utils/colors";

interface Pose2 {
  latitude: number;
  longitude: number;
  theta: number;
  z: number;
}

interface MapDetails2 {
  building: string;
  location_name: string;
  map: string;
  map_name: string;
  pose: Pose2;
  store_manager_id: string;
}

type DeliveryType = 'pickUp' | 'dropOff';

interface ToggleTabProps {
  tabValue: number;
  handleTabChange: (newValue: number, deliveryType: DeliveryType) => void; // This definition needs to match expected usage
  mapDetails: MapDetails3[];
  deliveryType: DeliveryType;
  handleLocationSelect: (location: string) => void;
  resetFocus: () => void;
}

const ToggleTab: React.FC<ToggleTabProps> = ({ tabValue, handleTabChange, mapDetails, deliveryType, handleLocationSelect }) => {
  const dispatch = useDispatch();
  // const uniqueLevels = Array.from(new Set(mapDetails.map(detail => detail.map[0].map_level)));
  const [uniqueLevels, setUniqueLevels] = useState<number[]>([])
  const [lastMapDetailsLength, setLastMapDetailsLength] = useState(0);

  useEffect(() => {
    if (mapDetails.length === 0) {
      return
    }

    if (lastMapDetailsLength > 0 && lastMapDetailsLength > mapDetails.length) {
      onChangeTab(0, deliveryType);
    }
    setLastMapDetailsLength(mapDetails.length);
    
  }, [mapDetails])

  useEffect(() => {
    if (mapDetails.length === 0) {
      return
    }
    const tmpRes: number[] = []

    mapDetails.forEach(detail => {
      const num = detail.map[0].map_level
      if (num && !tmpRes.includes(num)) {
        tmpRes.push(num);
      }
    })
    // const tmpRes = Array.from(new Set(mapDetails.map(detail => detail.map[0].map_level))).filter((value) => typeof value === 'number' && value !== undefined && value !== null);
    setUniqueLevels(tmpRes);
  }, [mapDetails])

  const onChangeTab = (newValue: number, deliveryType: DeliveryType) => {
    const selectedLevel = newValue - 1;
    // Find Map with specific name
    if (selectedLevel >= 0) {
      const findMap = mapDetails.find(detail => detail.map[0].map_level === uniqueLevels[selectedLevel])?.map[0]
      if (!findMap || !findMap.map_level) {
        return
      }
      dispatch(setCurrentFloor(findMap.map_level.toString()))
    }
    handleTabChange?.(newValue, deliveryType);
  }

  useEffect(() => {
    customLog(uniqueLevels);
    // Change Map Level based selected Tab (Except choose All Floor)
    const selectedLevel = tabValue - 1;
    if (selectedLevel < 0 || selectedLevel >= uniqueLevels.length) {
      return
    }
    // Find Map with specific name
    const findMap = mapDetails.find(detail => detail.map[0].map_level === uniqueLevels[selectedLevel])?.map[0]
    if (!findMap || !findMap.map_level) {
      return
    }
    // Set the Current Floor
    dispatch(setCurrentFloor(findMap.map_level.toString()))
  }
    , [uniqueLevels]);
  const renderLocationDetails = (locations: MapDetails3[], color: string, level: number | 'all') =>
  (
    <List>
      {locations.map((location, index) => (
        <React.Fragment key={index}>
          <ListItem button onClick={() => { handleLocationSelect(location.location_name) }} sx={{ '&:hover': { backgroundColor: '#f4f4f4' } }}>
            <ListItemIcon>
              <PlaceIcon sx={{ color: color }} />
            </ListItemIcon>
            <ListItemText>
              <Typography variant="subtitle1" sx={{ fontWeight: 550, color: "black", fontSize: "14px" }}>{location.map[0].building}</Typography>
              <Typography variant="subtitle2" sx={{ color: "#000", fontSize: "14px" }}>{location.location_name}</Typography>
              {level === 'all' && !!location.map[0].map_level && (
                <Typography variant="subtitle2" sx={{ color: COLOR.gray[500], fontSize: "12px" }}>
                  Level {getMapLevelLabel(location.map[0].map_level, { positivePrefix: '' })}
                </Typography>
              )}
            </ListItemText>
          </ListItem>
          {index < locations.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </List>
  );
  return (
    <Box sx={(theme) => ({
      [theme.breakpoints.up(VIEW.PHONE)]: {
        height: "calc(100vh - 212px)",
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        height: "calc(406px - 212px)",
      },
      [theme.breakpoints.up(VIEW.DESKTOP)]: {
        height: "calc(468px - 212px)",
      },
      display: "flex",
      flexDirection: "column",
      width: "100%",
      overflow: "auto"
    })}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'start',
          borderBottom: 1,
          alignItems: 'center',
          gap: 1,
          pl: 2,
          py: 1.5,
          overflowX: 'auto',
          overflowY: 'hidden',
          // minHeight: '56px',
          flex: 'none',
        }}
      >
        <Box sx={{
          flex: 'none',
          backgroundColor: tabValue === 0 ? '#00E58E' : 'transparent',
          borderRadius: '30px',
          px: 2,
          py: 0.5,
          userSelect: 'none',
          cursor: 'pointer',
          color: '#A0A0A0',
          fontSize: '12px',
        }} onClick={() => onChangeTab(0, deliveryType)}>
          <Typography sx={{ fontSize: '12px', color: tabValue === 0 ? '#087D46' : '#A0A0A0', textDecoration: 'uppercase' }}>
            ALL FLOORS
          </Typography>
        </Box>

        {uniqueLevels.map((level, index) => (
          <Box
            key={index}
            sx={{
              flex: 'none',
              backgroundColor: tabValue === (index + 1) ? '#00E58E' : 'transparent',
              borderRadius: '30px',
              px: 2,
              py: 0.5,
              userSelect: 'none',
              cursor: 'pointer',
              color: '#A0A0A0',
              fontSize: '12px',
            }}
            onClick={() => onChangeTab(index + 1, deliveryType)}>
            <Typography sx={{ fontSize: '12px', color: tabValue === (index + 1) ? '#087D46' : '#A0A0A0', textDecoration: 'uppercase' }}>
              LEVEL {getMapLevelLabel(level, { positivePrefix: '' })}
            </Typography>
          </Box>
        ))}
      </Box>
      <Box sx={{ mt: 0.5 }}>
        {tabValue === 0 && renderLocationDetails(mapDetails, deliveryType === "pickUp" ? "#378FFE" : "#FF0B0B", 'all')}
        {uniqueLevels.map((level, index) => (
          <Box key={index}>
            {tabValue === index + 1 && renderLocationDetails(mapDetails.filter(detail => detail.map[0].map_level === level), deliveryType === "pickUp" ? "#378FFE" : "#FF0B0B", level)}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default ToggleTab;